module.exports = __webpack_public_path__ + "static/media/layers-active.d9e7dc51.svg";